exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.leftArea[data-v-32372df3] {\n  line-height: 1.2em;\n}\n.rightArea[data-v-32372df3] {\n  white-space: nowrap;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-32372df3","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/modal/ReservationEditV2/TabReservation/reservationTicketPrice.vue
// module id = 1904
// module chunks = 0